<template>
    <div class="page td-fc" @click="showBox=true">
        <div class="title">单词基础</div>
        <div class="title-text">单词基础：以单词为核心，对单词，句子等进行基础与提高学习，并且可就全书范围进行智能听写。</div>
        <div class="td-fcc td-f1" v-if="cobwebInfo.name!=''">
            <StudyHomeCanvas :dataSource="cobwebInfo"></StudyHomeCanvas>
        </div>
        <div class="default-img" v-else>
            <p><span style="color: #e50114">单词</span>是</p>
            <p>听力的基础</p>
            <p>阅读的门槛</p>
            <p>写作的基础</p>
            <p>大家要仔细的阅读哦</p>
        </div>
        <!-- 学习弹窗 -->
        <transition name="el-fade-in" mode="out-in">
            <router-view></router-view>
        </transition>
        <dynamic-box :windowStatus="windowStatus" :data="wordStudyStage.dataSource" :type="wordStudyStage.type"
                     @callBack="callBack"></dynamic-box>
    </div>
</template>
<script>
    import {mapGetters, mapMutations} from "vuex";
    import Lockr from 'lockr'
    import {forcedReview, wordsCenter, wordReviewNum} from "@/api/words";
    import dynamicBox from "./templates/dynamicBox";
    import StudyHomeCanvas from "@/components/common/StudyHomeCanvas";

    export default {
        components: {dynamicBox, StudyHomeCanvas},
        computed: {
            ...mapGetters(['wordStudyStage'])
        },
        data() {
            return {
                isHint: false, //是否显示强制复习提示语
                isDemo: true,
                showAnswer: false, //是否显示答案
                spellInput: '',
                cobwebInfo: '', //蛛网信息
                forcedReviewInfo: [], //强制复习单词列表
                windowStatus: false,
                grammarInfo: {
                    studentId: '', //学生Id
                    reviewNum: '', //需要单词复习的个数
                }, //获取单词信息
            };
        },
        methods: {
            ...mapMutations(['CHANGE_WORD_STUDY_TYPE']),
            //获取个人信息
            async getUserInfo() {
                let params = {
                    token: Lockr.get('token')
                }
                let voiceOption = {
                    is_play: '',
                    memory_voice: '',
                    is_countdown: '',
                }
                let result = await wordsCenter(params)
                if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                    this.cobwebInfo = result.data.last_study
                    voiceOption.is_play = result.data.is_play
                    voiceOption.memory_voice = result.data.memory_voice
                    voiceOption.is_countdown = result.data.is_countdown
                    voiceOption.reverse_memory = result.data.reverse_memory
                    Lockr.set('voiceOption', voiceOption)
                    this.grammarInfo.studentId = result.data.student_id
                    if (result.data.is_review == 1) {
                        this.getReviewNum()
                    }
                } else {
                    this.$message({
                        message: result.msg,
                        type: 'warning'
                    });
                }
            },
            // 动态组件回调
            callBack(data) {
                if (data.type == 'close') {
                    this.windowStatus = false;
                }
            },
            // 获取需要强制复习的单词个数
            async getReviewNum() {
                let params = {
                    token: Lockr.get('token'),
                    student_id: this.grammarInfo.studentId
                }
                let result = await wordReviewNum(params)
                if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                    //需要单词复习的个数
                    this.grammarInfo.reviewNum = result.data
                    if (this.grammarInfo.reviewNum.count != 0) {
                        setTimeout(()=>{
                            let data = {
                                title: '强制复习',
                                type: 'compel/voiceDiscern',
                                dataSource: this.grammarInfo,
                                courseType: 'qzfx',
                            }
                            this.CHANGE_WORD_STUDY_TYPE(data)
                            this.windowStatus = true
                        }, 1000)
                    }
                } else {
                    this.$message({
                        message: result.msg,
                        type: 'warning'
                    });
                }
            },
        },
        created() {
            this.getUserInfo() //获取蛛网信息
        },
    }
</script>

<style scoped lang='less'>
    .page {
        height: 100%;
        padding-top: 10px;
        box-sizing: border-box;

        .title {
            display: flex;
            align-items: center;
            font-size: 18px;
            line-height: 1;
            font-weight: bold;
            padding-left: 10px;
            border-left: 3px solid #333;
        }

        .title-text {
            border: 2px solid #F5A623;
            padding: 12px 17px;
            margin: 15px;
            font-size: 14px;
            font-weight: bold;
            color: #333;
            line-height: 19px;
        }
    }

    .default-img {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        font-size: 30px;
        color: #333;
        width: 100%;
        height: 580px;
        margin: 0 auto;
        background-image: url('../../assets/img/default/home_default.png');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center center;
    }

    @media (max-width: 980px) {
        .default-img {
            font-size: 24px;
        }
    }

    @media (min-width: 1200px) {
        .title-text {
            font-size: 16px !important;
        }
    }
</style>